import React, { Fragment, lazy, Suspense } from 'react';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const Cart = lazy(()=>import('../../components/Cart/Cart'))

const CartPage = () => {
    return (
        <Fragment>
            <Suspense fallback={<LazyLoader/>}>
                <Cart/>
            </Suspense>
        </Fragment>
    );
};

export default CartPage;